import { Component } from 'react';

import { TextInput } from '@ce-cfbdigital/cgl-cfb-fe-foundation';
import PropTypes from 'prop-types';
import PubSub from 'pubsub-js';

import CustomIcon from '../CustomIcons';
import { SEARCH_RESULTS_DISPLAYED, SEARCH_RESULTS_EVENT } from '../utilities/constants';

import './styles/index.css';

/**
 *search icon const
 *
 */
const SearchIcon = ({ size }) => <CustomIcon type="search" size={size} className="search-icon" />;

/**
 *clear(X) icon const
 *
 * @param {*} { type : "clear" }
 */
// eslint-disable-next-line react/prop-types
const ClearIcon = ({ type, size }) => <CustomIcon type={type} size={size} className="clear-search-icon search-icon" />;

/**
 *SearchBox - component for a search input, providing a onChange and clear callback.
 *
 * @param {*} props {
 *  Please check README.md file for descriptions of all props.
 * }
 * @returns
 */
class SearchBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchFocused: false,
      searchHover: false,
      searchedText: props.initialValue,
      searchSuggestions: [],
      showSuggestions: false
    };
    // !IMPORTANT: Disabling this code for now because of a bug reported.
    // this.debounceLoadData = debounce(this.handleDebounceLoadData, props.debounceTime);
  }

  componentDidUpdate(prevProps) {
    const { initialValue } = this.props;
    if (prevProps.initialValue !== initialValue) {
      this.updateSearchText();
    }
  }

  // !IMPORTANT: Disabling this code for now because of a bug reported.
  // handleDebounceLoadData = text => {
  //   const { searchedText } = this.state;
  //   if (searchedText === text) {
  //     const { Get, predictSearchUrl } = this.props;
  //     const url = `${predictSearchUrl}&q=${encodeURIComponent(text)}`;
  //     Get(url, true)
  //       .then(responseJSON => {
  //         const {
  //           data: { suggestions }
  //         } = responseJSON;
  //         if (suggestions.length) {
  //           this.setState({ searchSuggestions: suggestions, showSuggestions: true });
  //         } else {
  //           this.setState({ searchSuggestions: suggestions, showSuggestions: false });
  //         }
  //       })
  //       .catch(error => {
  //         log.error(error);
  //       });
  //   }
  // };

  onKeyDown = event => {
    const { changeFilter } = this.props;
    if ((event.which === 13 || event.keyCode === 13) && event.target.value.length > 2) {
      this.setState({ showSuggestions: false, searchedText: event.target.value, searchSuggestions: [] });
      changeFilter(event.target.value);
      PubSub.publish(SEARCH_RESULTS_EVENT, this.getAnalyticsData(event.target.value));
    }
  };

  getAnalyticsData = (searchTerm = '') => {
    const { analytics } = this.props;
    return {
      description: SEARCH_RESULTS_DISPLAYED,
      event: SEARCH_RESULTS_DISPLAYED,
      search: {
        term: searchTerm
      },
      ...analytics
    };
  };

  setFocus = event => {
    if (event === 'react-mouseenter' || event === 'react-mouseout') {
      return this.setState(prevState => ({ searchHover: !prevState.searchHover }));
    }
    return this.setState(prevState => ({ searchFocused: !prevState.searchFocused }));
  };

  searchIconHandler = () => {
    const { searchedText } = this.state;
    const { changeFilter } = this.props;
    this.setState(prevState => ({
      showSuggestions: false,
      searchedText: prevState.searchedText,
      searchSuggestions: []
    }));
    changeFilter(searchedText);
    PubSub.publish(SEARCH_RESULTS_EVENT, this.getAnalyticsData(searchedText));
  };

  updateSearchText = () => {
    const { initialValue } = this.props;
    this.setState({ searchedText: initialValue });
  };

  changeFilter = text => {
    // !IMPORTANT: Disabling this code for now because of a bug reported.
    // const { predictSearchUrl, changeFilter } = this.props;
    // if (text.length > 2 && predictSearchUrl) {
    //   this.debounceLoadData(text);
    // } else {
    //   this.setState({ showSuggestions: false });
    //   if (text.length === 0) {
    //     changeFilter('');
    //   }
    // }
    // this.setState({ searchedText: text });
    const { changeFilter } = this.props;
    this.setState({ showSuggestions: false });
    if (text.length === 0) {
      changeFilter('');
    }
    this.setState({ searchedText: text });
  };

  clearFilter = () => {
    const { clearFilter } = this.props;
    this.setState({ searchedText: '', showSuggestions: false, searchSuggestions: [] });
    clearFilter();
  };

  selectSuggestionHandler = suggestion => {
    const { changeFilter } = this.props;
    this.setState({ showSuggestions: false, searchedText: suggestion, searchSuggestions: [] });
    changeFilter(suggestion);
    PubSub.publish(SEARCH_RESULTS_EVENT, this.getAnalyticsData(suggestion));
  };

  render() {
    const {
      searchPlaceholder,
      initialValue,
      wrapperClassNames,
      inputClassNames,
      clearIconType,
      refElement,
      children,
      disableClearButtonFocus,
      handleFocus,
      disableSearch,
      fullBorder,
      iconSize,
      hideClearIcon
    } = this.props;
    const { searchFocused, searchHover, searchedText, searchSuggestions, showSuggestions } = this.state;
    const showPlacholderIcon = initialValue ? '' : 'search-before-icon';
    const typographyClass = inputClassNames;
    const conditionalFocus = disableClearButtonFocus ? { tabIndex: '-1' } : {};
    const borderClass = fullBorder ? 'full-border' : '';
    return (
      <div className="search-box-component">
        <div
          className={`search-box ${
            disableSearch
              ? `${wrapperClassNames} search-disable search-disable-${borderClass} disable-search-click`
              : `${wrapperClassNames} search-${borderClass}`
          } ${searchFocused || searchHover ? `search-active search-active-${borderClass}` : ''}`}
        >
          {children}
          <div className={`search-box-inner ${showPlacholderIcon}`}>
            <button
              className={`${disableSearch ? 'search-icon-btn search-disable' : 'search-icon-btn'}`}
              type="button"
              onClick={this.searchIconHandler}
              disabled={!searchedText.length}
              aria-label="search"
            >
              <SearchIcon size={iconSize} />
            </button>
            <TextInput
              id="global-search"
              type="text"
              onChange={evt => {
                evt.persist();
                this.changeFilter(evt.target.value);
              }}
              value={searchedText}
              placeholder={searchPlaceholder}
              inputClassName={`search-input ${typographyClass} input-${borderClass}`}
              ariaLabel={searchPlaceholder}
              refElement={refElement}
              onKeyDown={this.onKeyDown}
              onFocus={() => {
                this.setFocus();
                handleFocus();
              }}
              onMouseEnter={() => this.setFocus('react-mouseenter')}
              onMouseOut={() => this.setFocus('react-mouseout')}
              onBlur={() => this.setFocus()}
            />
          </div>
          {!hideClearIcon && searchedText.length ? (
            <div className="search-btns">
              <button
                className="clear-icon-btn"
                onClick={this.clearFilter}
                type="button"
                {...conditionalFocus}
                data-event="common-click"
                data-metrics-desc="Clear Search Field"
                data-metrics-type="BTN"
                data-metrics-location="HDR"
              >
                <ClearIcon type={clearIconType} size={iconSize} />
              </button>
            </div>
          ) : null}
        </div>
        {showSuggestions && (
          <div className="search-suggestion-panel">
            <ul>
              {searchSuggestions.map((suggestion, key) => (
                <li key={key}>
                  <div
                    onClick={() => this.selectSuggestionHandler(suggestion)}
                    onKeyDown={() => this.selectSuggestionHandler(suggestion)}
                    role="button"
                    tabIndex="0"
                  >
                    <SearchIcon size="15" />
                    <span>{suggestion}</span>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    );
  }
}

SearchIcon.propTypes = {
  size: PropTypes.string
};

SearchIcon.defaultProps = {
  size: '25'
};

SearchBox.propTypes = {
  searchPlaceholder: PropTypes.string,
  initialValue: PropTypes.string,
  clearFilter: PropTypes.func.isRequired,
  changeFilter: PropTypes.func.isRequired,
  wrapperClassNames: PropTypes.string,
  inputClassNames: PropTypes.string,
  clearIconType: PropTypes.string,
  refElement: PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  children: PropTypes.node,
  onKeyDown: PropTypes.func,
  disableClearButtonFocus: PropTypes.bool,
  handleFocus: PropTypes.func,
  disableSearch: PropTypes.bool,
  fullBorder: PropTypes.bool,
  iconSize: PropTypes.string,
  hideClearIcon: PropTypes.bool,
  Get: PropTypes.func.isRequired,
  predictSearchUrl: PropTypes.string,
  debounceTime: PropTypes.number,
  analytics: PropTypes.instanceOf(Object)
};

SearchBox.defaultProps = {
  searchPlaceholder: 'Search',
  initialValue: '',
  wrapperClassNames: '',
  inputClassNames: '',
  clearIconType: 'clear',
  refElement: undefined,
  children: null,
  onKeyDown: () => {},
  handleFocus: () => {},
  disableClearButtonFocus: false,
  disableSearch: false,
  fullBorder: false,
  iconSize: '25',
  hideClearIcon: false,
  predictSearchUrl: '',
  debounceTime: 500,
  analytics: {}
};

export default SearchBox;
